import dynamic from 'next/dynamic';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';

/**
 * React Player is a large dependency used only on a few select pages
 * so we opt to load it dynamically with next/dynamic
 */
const Player = dynamic(() => import('ui/components/1-atoms/Media/Player/Player').then((mod) => mod.UI_Player), { ssr: false });
interface DynamicPlayerProps {
	url: string;
	poster?: string;
	loop?: boolean;
}
export const DynamicPlayer = ({ url, poster, loop }: DynamicPlayerProps) => {
	const dictionary = useDictionaryContext();
	return <Player url={url} poster={poster} loop={loop} playVideoText={dictionary.getAction('PlayVideo')} />;
};
